export interface FooterLink {
  label: string;
  /** In-app route. */
  to?: string;
  /** External or mailto destination. */
  href?: string;
}

export interface FooterGroup {
  title: string;
  links: FooterLink[];
}

export const CONTACT_EMAIL = "info@hay2u.ca";

// An entry without `to` or `href` is planned but its page does not exist yet
// (TODO-027); it is not rendered until a destination is added here.
export const FOOTER_GROUPS: FooterGroup[] = [
  {
    title: "Buy",
    links: [
      { label: "Product catalog", to: "/products" },
      { label: "How to place a bid" },
      { label: "How to accept an offer" },
      { label: "Transportation" },
    ],
  },
  {
    title: "Sell",
    links: [
      { label: "How to sell" },
      { label: "Producer hub", to: "/producer/hub" },
      { label: "Fees and services" },
    ],
  },
  {
    title: "Help",
    links: [
      { label: "Contact us", href: `mailto:${CONTACT_EMAIL}` },
      { label: "End user agreement" },
    ],
  },
  {
    title: "Hay2U",
    links: [{ label: "About Hay2U" }, { label: "Producers", to: "/producer/all" }],
  },
];

// Shown as plain text until the pages exist (owner decision D1, TODO-027).
export const LEGAL_LINKS: FooterLink[] = [
  { label: "Terms & Conditions" },
  { label: "Privacy Policy" },
  { label: "Cookies" },
];

export const hasDestination = (link: FooterLink): boolean =>
  Boolean(link.to || link.href);

export const getVisibleGroups = (
  groups: FooterGroup[] = FOOTER_GROUPS
): FooterGroup[] =>
  groups
    .map((group) => ({ ...group, links: group.links.filter(hasDestination) }))
    .filter((group) => group.links.length > 0);
